module.exports = __webpack_public_path__ + "img/Down_Roll_Body_Inactive.a6ed17c5.png";